import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddpcnbh36d: FaireProductEntity = {
  token: "p_ddpcnbh36d",
  type: "product",
  name: "Melati Classic Zero-Alcohol Botanical Spirit (no gift box)",
  brandToken: "b_5p3hx22es9",
  brandName: "Melati Drinks",
  imageUrl:
    "https://cdn.faire.com/fastly/32c3db8dcc57d8a0166fad137be1f8ecb89ca3a71095a29c0e307aa3badf623a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b3f42cc5c81187fd6f836fb4e2eb89dcf07b1d48b9c34bd2056eaccbd50f1cc2.png",
    "https://cdn.faire.com/fastly/eb9e3d24f42b53cf191edfa738e8b2d8103c49f8e386f1c7ef081f174a93cc39.jpeg",
    "https://cdn.faire.com/fastly/816fc4e1911a7a8c2bcab3e4dabaf35d85e39f7c4ba90e7def3dc7f66b450fa7.jpeg",
  ],
  priceDollars: 42.96,
  description:
    "Melati Drinks is Asia's First Non-Alcoholic Spirit. Born out of the royal courts of the Far East, we uncovered botanical tonic recipes served since 1293. Travel through the magnificent volcanic highlands of Asia in a bold, delicious and healthy alcohol alternative. Savor uplifting goji berries, aromatic Asian spices and a long dry bitter finish. Let’s raise a glass to your health!\n\nEach bottle directly supports women's future in Indonesia and is ethically made within a circular economy.\n\nHerbaceous, bitter and balanced, Melati Classic is a full-bodied non-alcoholic spirit with a dry finish for red wine lovers. Goji berries, fresh hibiscus and earthy raw cacao are balanced by bitter orange and grounded in warm asian spices. Best enjoyed with tonic water in a wine glass for a sophisticated drink.",
  tags: [],
  msrpDollars: 62.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:51.087Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
